import { api } from './authClient';

export function billingGet(path) {
  return api(`/api/billing${path}`);
}

export function billingSend(path, body) {
  return api(`/api/billing${path}`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function stripeHostUrl(url, host) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' && parsed.hostname === host;
  } catch {
    return false;
  }
}
